import { db } from '../../firebase/config';
import { doc, updateDoc } from 'firebase/firestore';

export function useChangeVocab() {
  const changeVocab = async (docId, changes) => {
    const vocabRef = doc(db, 'vocabList', docId);

    // Kopiere changes ohne userId (wird bei Updates nicht benötigt)
    const updatedChanges = { ...changes };

    // Konvertiere alle Felder mit dem Namen 'knownCounter' zu Zahlen
    if ('knownCounter' in updatedChanges) {
      updatedChanges.knownCounter = Number(updatedChanges.knownCounter);
    }

    await updateDoc(vocabRef, updatedChanges);
  };

  return {
    changeVocab
  };
}